export default __webpack_public_path__ + "static/media/twitter.cf8e78db.svg";